/**
 * Подложка под логотипом. Все шапки сервиса тёмные, поэтому тёмный логотип на них не виден.
 * Режим «авто»: смотрим на пиксели логотипа — если он тёмный и прозрачный, ставим светлую подложку.
 * Логотип со своим непрозрачным фоном (например, JPG на белом) подложки не требует.
 */
export type LogoBg = 'auto' | 'light' | 'none';

function needsPlate(img: HTMLImageElement): boolean {
  const h = 48;
  const w = Math.max(1, Math.round((img.naturalWidth || 300) / (img.naturalHeight || 150) * h));
  const c = document.createElement('canvas');
  c.width = Math.min(w, 400); c.height = h;
  const ctx = c.getContext('2d', { willReadFrequently: true });
  if (!ctx) return true;
  ctx.drawImage(img, 0, 0, c.width, c.height);
  const d = ctx.getImageData(0, 0, c.width, c.height).data;
  let opaque = 0, lum = 0, n = 0;
  for (let i = 0; i < d.length; i += 4) {
    n++;
    if (d[i + 3] < 128) continue;
    opaque++;
    lum += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
  }
  if (!opaque) return true;
  if (opaque / n > 0.92) return false;          // у логотипа свой фон
  return lum / opaque < 0.6;                     // тёмный или средний по яркости — на тёмной шапке не читается
}

export function setupLogo(wrap: HTMLElement, img: HTMLImageElement, mode: LogoBg) {
  const apply = (on: boolean) => wrap.classList.toggle('plate', on);
  if (mode === 'light') return apply(true);
  if (mode === 'none') return apply(false);
  const run = () => { try { apply(needsPlate(img)); } catch { apply(true); } };
  if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
}
